import styled from 'styled-components';

import { Link } from 'react-router-dom';

export const Small = styled(Link)`
  color: #707070;
  font-size: 1rem;
  padding: 10px 25px;

  &:hover {
    text-decoration: underline;
  }

  @media only screen and (max-width: 767px) {
    font-size: .85rem;
  }
`